import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';
import type { User } from '@klp/user';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_FAKTURA_PAYMENTS_ENABLE: boolean;
    }
}

// Helper functions
export const getFakturaPaymentsEnable = (): boolean =>
    getConfig('WEBAPP_FAKTURA_PAYMENTS_ENABLE', false);

export const FakturaModuleName = 'faktura';

export const FakturaRoutes = {
    moduleRoute: () => generateRoute([FakturaModuleName]),
    list: () => generateRoute([FakturaModuleName]),
};

export const FakturaAccess = (user?: User): boolean =>
    (user && (user.isSuperUser || user.isAdmin)) || false;

export const FakturaPaymentAccess = (user?: User): boolean =>
    (getFakturaPaymentsEnable() && user && user.isAdmin) || false;

export const FakturaMenuItems = [
    new SidebarMenuItem({
        route: FakturaRoutes.list(),
        matchRoute: FakturaRoutes.moduleRoute(),
        icon: IconName.WALLET,
        translation: 'frontPage.invoice.title',
        access: FakturaAccess,
    }),
];
